import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden" data-id="element-175">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/34vhrQ1Y87uCN6XUamVsmg/IMG_0167.jpg")',
      backgroundPosition: 'center',
      backgroundSize: 'cover'
    }} data-id="element-176">
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-charcoal/40 mix-blend-multiply" data-id="element-177" />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal/20 via-transparent to-charcoal/60" data-id="element-178" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mt-16" data-id="element-179">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="max-w-3xl mx-auto" data-id="element-180">
          <h1 className="font-playfair text-5xl md:text-6xl lg:text-7xl text-white font-bold leading-tight mb-6" data-id="element-181">
            Where Every Bottle <br className="hidden md:block" data-id="element-182" />
            Tells <span className="text-gold italic" data-id="element-183">Your Story</span>
          </h1>

          <p className="text-lg md:text-xl text-cream-100 mb-10 max-w-2xl mx-auto font-light leading-relaxed" data-id="element-184">
            Improve how wine is selected, consumed, and presented. We offer
            curated wines and custom label services that make every experience
            personal, accessible, and memorable.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-185">
            <a href="#collection" className="w-full sm:w-auto px-8 py-4 bg-wine text-white rounded-sm font-medium hover:bg-wine-700 transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-186">
              Explore Our Wines
            </a>
            <a href="/design" className="w-full sm:w-auto px-8 py-4 bg-transparent border border-white/30 text-white rounded-sm font-medium hover:bg-white/10 hover:border-white transition-all duration-300 backdrop-blur-sm" data-id="element-187">
              Design Your Label
            </a>
          </div>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10" data-id="element-188">
        <motion.a href="#about" animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} className="flex flex-col items-center text-white/70 hover:text-white transition-colors" aria-label="Scroll down" data-id="element-189">
          <span className="text-xs uppercase tracking-widest mb-2 font-medium" data-id="element-190">
            Discover
          </span>
          <ChevronDownIcon className="w-5 h-5" data-id="element-191" />
        </motion.a>
      </motion.div>
    </section>;
}